import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6ce13956"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "margin-bottom": "10px"
  }
};
const _hoisted_2 = {
  class: "content title"
};
const _hoisted_3 = {
  key: 0,
  style: {
    "margin-top": "12px"
  }
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-section-title"
}, "实力值", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "主队实力", -1));
const _hoisted_7 = {
  class: "analysis-value home-color"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "客队实力", -1));
const _hoisted_9 = {
  class: "analysis-value away-color"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "实力差", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-section-title"
}, "盘口对比", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "计算盘口", -1));
const _hoisted_13 = {
  class: "analysis-value"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "机构盘口", -1));
const _hoisted_15 = {
  class: "analysis-value"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "盘口差值", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "价值判断", -1));
const _hoisted_18 = {
  key: 1,
  class: "no-data"
};
const _hoisted_19 = {
  key: 1,
  style: {
    "margin-top": "12px"
  }
};
const _hoisted_20 = {
  key: 0
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-section-title"
}, "胜平负热度 (HAD)", -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "胜", -1));
const _hoisted_23 = {
  class: "analysis-value home-color"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "平", -1));
const _hoisted_25 = {
  class: "analysis-value"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "负", -1));
const _hoisted_27 = {
  class: "analysis-value away-color"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-section-title"
}, "让胜平负热度 (HHAD)", -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "让胜", -1));
const _hoisted_30 = {
  class: "analysis-value home-color"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "让平", -1));
const _hoisted_32 = {
  class: "analysis-value"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "让负", -1));
const _hoisted_34 = {
  class: "analysis-value away-color"
};
const _hoisted_35 = {
  key: 1,
  class: "no-data"
};
const _hoisted_36 = {
  key: 2,
  style: {
    "margin-top": "12px"
  }
};
const _hoisted_37 = {
  key: 0
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-section-title"
}, "拉力值", -1));
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "主队拉力", -1));
const _hoisted_40 = {
  class: "analysis-value home-color"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "客队拉力", -1));
const _hoisted_42 = {
  class: "analysis-value away-color"
};
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "拉力差", -1));
const _hoisted_44 = {
  key: 1,
  class: "no-data"
};
const _hoisted_45 = {
  key: 3,
  style: {
    "margin-top": "12px"
  }
};
const _hoisted_46 = {
  key: 0
};
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "置信度", -1));
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "风险等级", -1));
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "主要驱动", -1));
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-section-title"
}, "基本面得分", -1));
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "主队", -1));
const _hoisted_52 = {
  class: "analysis-value home-color"
};
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "客队", -1));
const _hoisted_54 = {
  class: "analysis-value away-color"
};
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-section-title"
}, "亚盘推荐", -1));
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "盘口", -1));
const _hoisted_57 = {
  class: "analysis-value"
};
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "置信度", -1));
const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "主队水位", -1));
const _hoisted_60 = {
  class: "analysis-value"
};
const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "客队水位", -1));
const _hoisted_62 = {
  class: "analysis-value"
};
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-section-title"
}, "热度校验", -1));
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "过热风险", -1));
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "热度系数", -1));
const _hoisted_66 = {
  class: "analysis-value"
};
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "盘口价值", -1));
const _hoisted_68 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-label"
}, "价值支撑", -1));
const _hoisted_69 = {
  class: "analysis-section-title"
};
const _hoisted_70 = {
  style: {
    "margin-top": "12px"
  }
};
const _hoisted_71 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "analysis-section-title"
}, "推理过程", -1));
const _hoisted_72 = {
  class: "reasoning-icon"
};
const _hoisted_73 = {
  class: "reasoning-content"
};
const _hoisted_74 = {
  class: "reasoning-tag"
};
const _hoisted_75 = {
  class: "reasoning-text"
};
const _hoisted_76 = {
  key: 1,
  class: "no-data"
};
import { ref, nextTick, computed } from 'vue';
import axios from 'axios';
import * as echarts from 'echarts';
export default {
  __name: 'MatchAnalysisView',
  setup(__props, {
    expose: __expose
  }) {
    const isVisible = ref(false);
    const loading = ref(false);
    const activeTab = ref(0);
    const matchId = ref('');
    const homeTeam = ref('');
    const awayTeam = ref('');
    const leagueName = ref('');
    const leagueType = ref('');
    const seasonPhase = ref('');

    // 联赛类型中文映射
    const leagueTypeMap = {
      TOP5: '五大联赛',
      SECOND_TIER: '二级联赛',
      MID_EUROPE: '中欧联赛',
      ASIAN: '亚洲联赛',
      AMERICAS: '美洲联赛',
      CUP: '杯赛',
      NATIONAL: '国家队',
      OTHER: '其他'
    };
    // 赛季阶段中文映射
    const seasonPhaseMap = {
      EARLY: '赛季初期',
      MID: '赛季中期',
      LATE: '赛季后期',
      CUP_KO: '淘汰赛'
    };
    const leagueTypeLabel = computed(() => leagueTypeMap[leagueType.value] || '其他');
    const seasonPhaseLabel = computed(() => seasonPhaseMap[seasonPhase.value] || '');
    const leagueTypeChip = computed(() => {
      const t = leagueType.value;
      if (t === 'TOP5') return 'danger';
      if (t === 'SECOND_TIER') return 'warning';
      if (t === 'CUP' || t === 'NATIONAL') return 'primary';
      return 'default';
    });
    const seasonPhaseChip = computed(() => {
      const p = seasonPhase.value;
      if (p === 'EARLY') return 'warning';
      if (p === 'LATE') return 'danger';
      if (p === 'CUP_KO') return 'primary';
      return 'success';
    });
    const strengthData = ref(null);
    const heatData = ref(null);
    const pullData = ref(null);
    const recData = ref(null);
    const strengthChartRef = ref(null);
    const heatChartRef = ref(null);
    const pullChartRef = ref(null);
    let strengthChart = null;
    let heatChart = null;
    let pullChart = null;
    const show = id => {
      matchId.value = id;
      isVisible.value = true;
      activeTab.value = 0;
      strengthData.value = null;
      heatData.value = null;
      pullData.value = null;
      recData.value = null;
      fetchAnalysis();
    };
    const close = () => {
      isVisible.value = false;
      disposeCharts();
    };
    const onTabChange = index => {
      nextTick(() => {
        if (index === 0 && strengthData.value) renderStrengthChart();
        if (index === 1 && heatData.value) renderHeatChart();
        if (index === 2 && pullData.value) renderPullChart();
      });
    };
    const fetchAnalysis = async () => {
      loading.value = true;
      try {
        const response = await axios.get(`https://tuhaojie.asia/api-foot/matchAnalysis/all?matchId=${matchId.value}`);
        const data = response.data?.data || response.data;
        if (data) {
          homeTeam.value = data.homeTeam || '';
          awayTeam.value = data.awayTeam || '';
          leagueName.value = data.leagueName || '';
          leagueType.value = data.leagueType || '';
          seasonPhase.value = data.seasonPhase || '';
          strengthData.value = data.strengthDiff;
          heatData.value = data.heatAnalysis;
          pullData.value = data.pullAnalysis;
          recData.value = data.recommendation;
          nextTick(() => renderStrengthChart());
        }
      } catch (e) {
        console.error('获取分析数据失败', e);
      } finally {
        loading.value = false;
      }
    };
    const disposeCharts = () => {
      if (strengthChart) {
        strengthChart.dispose();
        strengthChart = null;
      }
      if (heatChart) {
        heatChart.dispose();
        heatChart = null;
      }
      if (pullChart) {
        pullChart.dispose();
        pullChart = null;
      }
    };

    // ==================== 实力差雷达图 ====================
    const renderStrengthChart = () => {
      if (!strengthChartRef.value || !strengthData.value) return;
      if (strengthChart) strengthChart.dispose();
      strengthChart = echarts.init(strengthChartRef.value);
      const d = strengthData.value;
      strengthChart.setOption({
        title: {
          text: '实力构成对比',
          left: 'center',
          textStyle: {
            fontSize: 13
          }
        },
        legend: {
          data: ['主队', '客队'],
          bottom: 0
        },
        radar: {
          indicator: [{
            name: '进攻',
            max: 100
          }, {
            name: '防守',
            max: 100
          }, {
            name: '状态',
            max: 100
          }, {
            name: '交锋',
            max: 100
          }],
          radius: '60%'
        },
        series: [{
          type: 'radar',
          data: [{
            value: [d.homeOffensive, d.homeDefensive, d.homeForm, d.homeH2h],
            name: '主队',
            areaStyle: {
              color: 'rgba(231,76,60,0.2)'
            },
            lineStyle: {
              color: '#e74c3c'
            },
            itemStyle: {
              color: '#e74c3c'
            }
          }, {
            value: [d.awayOffensive, d.awayDefensive, d.awayForm, d.awayH2h],
            name: '客队',
            areaStyle: {
              color: 'rgba(52,152,219,0.2)'
            },
            lineStyle: {
              color: '#3498db'
            },
            itemStyle: {
              color: '#3498db'
            }
          }]
        }]
      });
    };

    // ==================== 热度趋势图 ====================
    const renderHeatChart = () => {
      if (!heatChartRef.value || !heatData.value) return;
      if (heatChart) heatChart.dispose();
      heatChart = echarts.init(heatChartRef.value);
      const d = heatData.value;
      heatChart.setOption({
        title: {
          text: '热度构成对比',
          left: 'center',
          textStyle: {
            fontSize: 13
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['支持率', '资金流向', '赔率变化'],
          bottom: 0
        },
        grid: {
          left: '15%',
          right: '5%',
          top: '15%',
          bottom: '15%'
        },
        xAxis: {
          type: 'category',
          data: ['胜', '平', '负']
        },
        yAxis: {
          type: 'value',
          max: 100
        },
        series: [{
          name: '支持率',
          type: 'bar',
          data: [d.hadHomeDetail?.supportRateScore, d.hadDrawDetail?.supportRateScore, d.hadAwayDetail?.supportRateScore],
          itemStyle: {
            color: '#e74c3c'
          }
        }, {
          name: '资金流向',
          type: 'bar',
          data: [d.hadHomeDetail?.moneyScore, d.hadDrawDetail?.moneyScore, d.hadAwayDetail?.moneyScore],
          itemStyle: {
            color: '#f39c12'
          }
        }, {
          name: '赔率变化',
          type: 'bar',
          data: [d.hadHomeDetail?.oddsChangeScore, d.hadDrawDetail?.oddsChangeScore, d.hadAwayDetail?.oddsChangeScore],
          itemStyle: {
            color: '#3498db'
          }
        }]
      });
    };

    // ==================== 拉力对比条形图 ====================
    const renderPullChart = () => {
      if (!pullChartRef.value || !pullData.value) return;
      if (pullChart) pullChart.dispose();
      pullChart = echarts.init(pullChartRef.value);
      const d = pullData.value;
      const categories = ['近期状态', '主场优势', '排名', '交锋', '战意', '赔率走势'];
      const homeValues = [d.homeDetail?.formPull, d.homeDetail?.homeAdvPull, d.homeDetail?.rankPull, d.homeDetail?.h2hPull, d.homeDetail?.motivationPull, d.homeDetail?.oddsTrendPull];
      const awayValues = [d.awayDetail?.formPull, d.awayDetail?.homeAdvPull, d.awayDetail?.rankPull, d.awayDetail?.h2hPull, d.awayDetail?.motivationPull, d.awayDetail?.oddsTrendPull];
      pullChart.setOption({
        title: {
          text: '拉力构成对比',
          left: 'center',
          textStyle: {
            fontSize: 13
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['主队', '客队'],
          bottom: 0
        },
        grid: {
          left: '20%',
          right: '5%',
          top: '10%',
          bottom: '10%'
        },
        yAxis: {
          type: 'category',
          data: categories
        },
        xAxis: {
          type: 'value',
          max: 100
        },
        series: [{
          name: '主队',
          type: 'bar',
          data: homeValues,
          itemStyle: {
            color: '#e74c3c'
          },
          barWidth: 10
        }, {
          name: '客队',
          type: 'bar',
          data: awayValues,
          itemStyle: {
            color: '#3498db'
          },
          barWidth: 10
        }]
      });
    };
    __expose({
      show,
      close
    });

    // ==================== 推荐tab样式计算 ====================
    const recDirectionClass = computed(() => {
      const d = recData.value?.direction;
      if (d === '主胜') return 'home-color';
      if (d === '客胜') return 'away-color';
      return 'draw-color';
    });
    const recConfidenceClass = computed(() => {
      const c = recData.value?.confidence;
      if (c >= 70) return 'high-confidence';
      if (c >= 40) return 'mid-confidence';
      return 'low-confidence';
    });
    const recConfidenceColor = computed(() => {
      const c = recData.value?.confidence;
      if (c >= 70) return '#27ae60';
      if (c >= 40) return '#f39c12';
      return '#e74c3c';
    });
    const recRiskChipType = computed(() => {
      const r = recData.value?.riskLevel;
      if (r === 'High') return 'danger';
      if (r === 'Medium') return 'warning';
      return 'success';
    });
    const recRiskLabel = computed(() => {
      const r = recData.value?.riskLevel;
      if (r === 'High') return '高风险';
      if (r === 'Medium') return '中风险';
      return '低风险';
    });

    // ==================== 亚盘推荐样式计算 ====================
    const asianRecClass = computed(() => {
      const r = recData.value?.asianRecommendation;
      if (!r) return '';
      if (r.includes('上盘(主)')) return 'home-color';
      if (r.includes('上盘(客)')) return 'away-color';
      if (r.includes('下盘(平)')) return 'draw-color';
      return '';
    });
    const asianConfClass = computed(() => {
      const c = recData.value?.asianConfidence;
      if (!c) return '';
      if (c >= 70) return 'high-confidence';
      if (c >= 50) return 'mid-confidence';
      return 'low-confidence';
    });
    const formatHandicap = h => {
      if (h === null || h === undefined || h === 0) return '平手';
      if (h < 0) return `主让${Math.abs(h)}`;
      return `客让${h}`;
    };

    // ==================== 推理链解析 ====================
    const getReasoningIcon = step => {
      if (step.includes('⚠️')) return '⚠️';
      if (step.includes('✅')) return '✅';
      if (step.includes('实力差')) return '💪';
      if (step.includes('拉力值')) return '🧲';
      if (step.includes('热度值')) return '🔥';
      if (step.includes('基本面')) return '📊';
      if (step.includes('主要驱动')) return '🎯';
      if (step.includes('亚盘')) return '🎰';
      if (step.includes('亚盘平局')) return '🎰';
      if (step.includes('热度校验')) return '🌡️';
      if (step.includes('矛盾检测')) return '⚡';
      if (step.includes('置信度')) return '📈';
      if (step.includes('风险等级')) return '🛡️';
      return '📌';
    };
    const getReasoningTag = step => {
      const m = step.match(/【(.+?)】/);
      return m ? m[1] : '分析';
    };
    const getReasoningText = step => {
      return step.replace(/【.+?】/, '').trim();
    };
    const getReasoningClass = step => {
      if (step.includes('⚠️')) return 'reasoning-warn';
      if (step.includes('✅')) return 'reasoning-good';
      if (step.includes('矛盾')) return 'reasoning-warn';
      if (step.includes('风险等级') && step.includes('High')) return 'reasoning-warn';
      if (step.includes('风险等级') && step.includes('Low')) return 'reasoning-good';
      return '';
    };
    return (_ctx, _cache) => {
      const _component_nut_col = _resolveComponent("nut-col");
      const _component_nut_row = _resolveComponent("nut-row");
      const _component_var_chip = _resolveComponent("var-chip");
      const _component_var_col = _resolveComponent("var-col");
      const _component_var_row = _resolveComponent("var-row");
      const _component_var_tab = _resolveComponent("var-tab");
      const _component_var_tabs = _resolveComponent("var-tabs");
      const _component_var_progress = _resolveComponent("var-progress");
      const _component_var_loading = _resolveComponent("var-loading");
      const _component_nut_popup = _resolveComponent("nut-popup");
      return _openBlock(), _createBlock(_component_nut_popup, {
        visible: isVisible.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = $event => isVisible.value = $event),
        closeable: "",
        style: {
          padding: '50px 10px',
          height: '85%',
          width: '90%',
          overflowY: 'auto',
          overflowX: 'hidden'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_var_loading, {
          description: "加载中",
          loading: loading.value
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_nut_row, null, {
            default: _withCtx(() => [_createVNode(_component_nut_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_2, _toDisplayString(homeTeam.value) + " vs " + _toDisplayString(awayTeam.value), 1)]),
              _: 1
            })]),
            _: 1
          }), leagueName.value ? (_openBlock(), _createBlock(_component_var_row, {
            key: 0,
            gutter: [4, 4],
            style: {
              "margin-top": "4px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_var_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_var_chip, {
                size: "small",
                type: leagueTypeChip.value
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(leagueName.value), 1)]),
                _: 1
              }, 8, ["type"])]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_var_chip, {
                size: "small",
                type: "default"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(leagueTypeLabel.value), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_var_chip, {
                size: "small",
                type: seasonPhaseChip.value
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(seasonPhaseLabel.value), 1)]),
                _: 1
              }, 8, ["type"])]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true)]), _createVNode(_component_var_tabs, {
            active: activeTab.value,
            "onUpdate:active": _cache[0] || (_cache[0] = $event => activeTab.value = $event),
            onChange: onTabChange
          }, {
            default: _withCtx(() => [_createVNode(_component_var_tab, null, {
              default: _withCtx(() => [_createTextVNode("实力差")]),
              _: 1
            }), _createVNode(_component_var_tab, null, {
              default: _withCtx(() => [_createTextVNode("热度值")]),
              _: 1
            }), _createVNode(_component_var_tab, null, {
              default: _withCtx(() => [_createTextVNode("拉力值")]),
              _: 1
            }), _createVNode(_component_var_tab, null, {
              default: _withCtx(() => [_createTextVNode("综合推荐")]),
              _: 1
            })]),
            _: 1
          }, 8, ["active"]), activeTab.value === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [strengthData.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_var_row, {
            gutter: [8, 8]
          }, {
            default: _withCtx(() => [_createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_5]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_6, _createElementVNode("div", _hoisted_7, _toDisplayString(strengthData.value.homeStrength), 1), _createVNode(_component_var_progress, {
                value: strengthData.value.homeStrength,
                max: 100,
                color: "#e74c3c"
              }, null, 8, ["value"])]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_8, _createElementVNode("div", _hoisted_9, _toDisplayString(strengthData.value.awayStrength), 1), _createVNode(_component_var_progress, {
                value: strengthData.value.awayStrength,
                max: 100,
                color: "#3498db"
              }, null, 8, ["value"])]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_10, _createElementVNode("div", {
                class: _normalizeClass([strengthData.value.strengthDiff > 0 ? 'home-color' : 'away-color', "analysis-value"])
              }, _toDisplayString(strengthData.value.strengthDiff > 0 ? '+' : '') + _toDisplayString(strengthData.value.strengthDiff) + " (" + _toDisplayString(strengthData.value.strengthDiff > 0 ? '主队占优' : '客队占优') + ") ", 3)]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_var_row, {
            gutter: [8, 8],
            style: {
              "margin-top": "12px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_11]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_12, _createElementVNode("div", _hoisted_13, _toDisplayString(strengthData.value.calculatedHandicap), 1)]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_14, _createElementVNode("div", _hoisted_15, _toDisplayString(strengthData.value.actualHandicap), 1)]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_16, _createElementVNode("div", {
                class: _normalizeClass([Math.abs(strengthData.value.handicapDiff) > 0.25 ? 'warn-color' : '', "analysis-value"])
              }, _toDisplayString(strengthData.value.handicapDiff), 3)]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_17, _createVNode(_component_var_chip, {
                type: strengthData.value.handicapDiffLabel === '盘口合理' ? 'primary' : 'danger',
                block: ""
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(strengthData.value.handicapDiffLabel), 1)]),
                _: 1
              }, 8, ["type"])]),
              _: 1
            })]),
            _: 1
          }), _createElementVNode("div", {
            ref_key: "strengthChartRef",
            ref: strengthChartRef,
            style: {
              "height": "260px",
              "margin-top": "12px"
            }
          }, null, 512)])) : (_openBlock(), _createElementBlock("div", _hoisted_18, "暂无实力差数据"))])) : _createCommentVNode("", true), activeTab.value === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_19, [heatData.value ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(_component_var_row, {
            gutter: [8, 8]
          }, {
            default: _withCtx(() => [_createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_21]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_22, _createElementVNode("div", _hoisted_23, _toDisplayString(heatData.value.hadHomeHeat), 1), _createVNode(_component_var_progress, {
                value: heatData.value.hadHomeHeat,
                max: 100,
                color: "#e74c3c"
              }, null, 8, ["value"])]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_24, _createElementVNode("div", _hoisted_25, _toDisplayString(heatData.value.hadDrawHeat), 1), _createVNode(_component_var_progress, {
                value: heatData.value.hadDrawHeat,
                max: 100,
                color: "#f39c12"
              }, null, 8, ["value"])]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_26, _createElementVNode("div", _hoisted_27, _toDisplayString(heatData.value.hadAwayHeat), 1), _createVNode(_component_var_progress, {
                value: heatData.value.hadAwayHeat,
                max: 100,
                color: "#3498db"
              }, null, 8, ["value"])]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_var_chip, {
                type: heatData.value.hadHeatDirection === '主热' ? 'danger' : heatData.value.hadHeatDirection === '客热' ? 'primary' : 'default',
                block: ""
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(heatData.value.hadHeatDirection), 1)]),
                _: 1
              }, 8, ["type"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_var_row, {
            gutter: [8, 8],
            style: {
              "margin-top": "12px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_28]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_29, _createElementVNode("div", _hoisted_30, _toDisplayString(heatData.value.hhadHomeHeat), 1), _createVNode(_component_var_progress, {
                value: heatData.value.hhadHomeHeat,
                max: 100,
                color: "#e74c3c"
              }, null, 8, ["value"])]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_31, _createElementVNode("div", _hoisted_32, _toDisplayString(heatData.value.hhadDrawHeat), 1), _createVNode(_component_var_progress, {
                value: heatData.value.hhadDrawHeat,
                max: 100,
                color: "#f39c12"
              }, null, 8, ["value"])]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_33, _createElementVNode("div", _hoisted_34, _toDisplayString(heatData.value.hhadAwayHeat), 1), _createVNode(_component_var_progress, {
                value: heatData.value.hhadAwayHeat,
                max: 100,
                color: "#3498db"
              }, null, 8, ["value"])]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_var_chip, {
                type: heatData.value.hhadHeatDirection === '主热' ? 'danger' : heatData.value.hhadHeatDirection === '客热' ? 'primary' : 'default',
                block: ""
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(heatData.value.hhadHeatDirection), 1)]),
                _: 1
              }, 8, ["type"])]),
              _: 1
            })]),
            _: 1
          }), _createElementVNode("div", {
            ref_key: "heatChartRef",
            ref: heatChartRef,
            style: {
              "height": "260px",
              "margin-top": "12px"
            }
          }, null, 512)])) : (_openBlock(), _createElementBlock("div", _hoisted_35, "暂无热度值数据"))])) : _createCommentVNode("", true), activeTab.value === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_36, [pullData.value ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createVNode(_component_var_row, {
            gutter: [8, 8]
          }, {
            default: _withCtx(() => [_createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_38]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_39, _createElementVNode("div", _hoisted_40, _toDisplayString(pullData.value.homePull), 1), _createVNode(_component_var_progress, {
                value: pullData.value.homePull,
                max: 100,
                color: "#e74c3c"
              }, null, 8, ["value"])]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_41, _createElementVNode("div", _hoisted_42, _toDisplayString(pullData.value.awayPull), 1), _createVNode(_component_var_progress, {
                value: pullData.value.awayPull,
                max: 100,
                color: "#3498db"
              }, null, 8, ["value"])]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_43, _createElementVNode("div", {
                class: _normalizeClass([pullData.value.pullDiff > 0 ? 'home-color' : 'away-color', "analysis-value"])
              }, _toDisplayString(pullData.value.pullDiff > 0 ? '+' : '') + _toDisplayString(pullData.value.pullDiff) + " (" + _toDisplayString(pullData.value.pullDirection) + ") ", 3)]),
              _: 1
            })]),
            _: 1
          }), _createElementVNode("div", {
            ref_key: "pullChartRef",
            ref: pullChartRef,
            style: {
              "height": "320px",
              "margin-top": "12px"
            }
          }, null, 512)])) : (_openBlock(), _createElementBlock("div", _hoisted_44, "暂无拉力值数据"))])) : _createCommentVNode("", true), activeTab.value === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_45, [recData.value ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_createVNode(_component_var_row, {
            gutter: [8, 8]
          }, {
            default: _withCtx(() => [_createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createElementVNode("div", {
                class: _normalizeClass(["rec-direction", recDirectionClass.value])
              }, _toDisplayString(recData.value.direction), 3)]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_47, _createElementVNode("div", {
                class: _normalizeClass(["analysis-value", recConfidenceClass.value])
              }, _toDisplayString(recData.value.confidence) + "%", 3), _createVNode(_component_var_progress, {
                value: recData.value.confidence,
                max: 100,
                color: recConfidenceColor.value
              }, null, 8, ["value", "color"])]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_48, _createVNode(_component_var_chip, {
                type: recRiskChipType.value,
                block: ""
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(recRiskLabel.value), 1)]),
                _: 1
              }, 8, ["type"])]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24,
              style: {
                "margin-top": "4px"
              }
            }, {
              default: _withCtx(() => [_hoisted_49, _createVNode(_component_var_chip, {
                type: "primary"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(recData.value.primaryDriver), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_var_row, {
            gutter: [8, 8],
            style: {
              "margin-top": "12px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_50]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_51, _createElementVNode("div", _hoisted_52, _toDisplayString(recData.value.homeFundamentalScore), 1), _createVNode(_component_var_progress, {
                value: recData.value.homeFundamentalScore,
                max: 100,
                color: "#e74c3c"
              }, null, 8, ["value"])]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_53, _createElementVNode("div", _hoisted_54, _toDisplayString(recData.value.awayFundamentalScore), 1), _createVNode(_component_var_progress, {
                value: recData.value.awayFundamentalScore,
                max: 100,
                color: "#3498db"
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          }), recData.value.asianRecommendation ? (_openBlock(), _createBlock(_component_var_row, {
            key: 0,
            gutter: [8, 8],
            style: {
              "margin-top": "12px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_55]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createElementVNode("div", {
                class: _normalizeClass(["rec-asian-direction", asianRecClass.value])
              }, _toDisplayString(recData.value.asianRecommendation), 3)]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 12
            }, {
              default: _withCtx(() => [_hoisted_56, _createElementVNode("div", _hoisted_57, _toDisplayString(formatHandicap(recData.value.asianHandicap)), 1)]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 12
            }, {
              default: _withCtx(() => [_hoisted_58, _createElementVNode("div", {
                class: _normalizeClass(["analysis-value", asianConfClass.value])
              }, _toDisplayString(recData.value.asianConfidence) + "%", 3)]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 12
            }, {
              default: _withCtx(() => [_hoisted_59, _createElementVNode("div", _hoisted_60, _toDisplayString(recData.value.asianHomeWater || '-'), 1)]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 12
            }, {
              default: _withCtx(() => [_hoisted_61, _createElementVNode("div", _hoisted_62, _toDisplayString(recData.value.asianAwayWater || '-'), 1)]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_var_row, {
            gutter: [8, 8],
            style: {
              "margin-top": "12px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_63]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_64, _createVNode(_component_var_chip, {
                type: recData.value.isOverheat ? 'danger' : 'success',
                block: ""
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(recData.value.isOverheat ? '过热' : '安全'), 1)]),
                _: 1
              }, 8, ["type"])]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_65, _createElementVNode("div", _hoisted_66, _toDisplayString(recData.value.heatPenaltyFactor), 1)]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_67, _createVNode(_component_var_chip, {
                type: recData.value.handicapValueSignal === '盘口合理' ? 'default' : 'primary',
                block: ""
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(recData.value.handicapValueSignal), 1)]),
                _: 1
              }, 8, ["type"])]),
              _: 1
            }), _createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_hoisted_68, recData.value.handicapValueSupports !== null && recData.value.handicapValueSupports !== undefined ? (_openBlock(), _createBlock(_component_var_chip, {
                key: 0,
                type: recData.value.handicapValueSupports ? 'success' : 'danger',
                block: ""
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(recData.value.handicapValueSupports ? '支撑' : '矛盾'), 1)]),
                _: 1
              }, 8, ["type"])) : (_openBlock(), _createBlock(_component_var_chip, {
                key: 1,
                type: "default",
                block: ""
              }, {
                default: _withCtx(() => [_createTextVNode("无信号")]),
                _: 1
              }))]),
              _: 1
            })]),
            _: 1
          }), recData.value.contradictions && recData.value.contradictions.length > 0 ? (_openBlock(), _createBlock(_component_var_row, {
            key: 1,
            gutter: [8, 8],
            style: {
              "margin-top": "12px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_var_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_69, "矛盾检测 (" + _toDisplayString(recData.value.contradictionCount) + ")", 1)]),
              _: 1
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recData.value.contradictions, (c, i) => {
              return _openBlock(), _createBlock(_component_var_col, {
                span: 24,
                key: i
              }, {
                default: _withCtx(() => [_createVNode(_component_var_chip, {
                  type: "warning",
                  size: "small",
                  style: {
                    "margin": "2px"
                  }
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(c), 1)]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_70, [_hoisted_71, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recData.value.reasoningChain, (step, i) => {
            return _openBlock(), _createElementBlock("div", {
              key: i,
              class: _normalizeClass(["reasoning-card", getReasoningClass(step)])
            }, [_createElementVNode("div", _hoisted_72, _toDisplayString(getReasoningIcon(step)), 1), _createElementVNode("div", _hoisted_73, [_createElementVNode("div", _hoisted_74, _toDisplayString(getReasoningTag(step)), 1), _createElementVNode("div", _hoisted_75, _toDisplayString(getReasoningText(step)), 1)])], 2);
          }), 128))])])) : (_openBlock(), _createElementBlock("div", _hoisted_76, "暂无推荐数据"))])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["loading"])]),
        _: 1
      }, 8, ["visible"]);
    };
  }
};